"use client";

import { Card, CardContent } from "@/components/ui/card";
import {
  AVS_SELLING_TYPE_FLOTTE,
  AVS_SELLING_TYPE_VDL,
  AVS_SELLING_TYPE_VDS,
  type SalesTypeValue,
} from "@/components/backoffice/cat/vehicle-assignment/sales-channels-step";

import { AvsFleetAdditionalInformations } from "./fleet-additional-informations";
import { AvsVdlVdsAdditionalInformations } from "./vdl-vds-additional-informations";

export interface AvsAdditionalInformationsStepProps {
  salesChannel: SalesTypeValue | "";
  onCanProceedChange?: (canProceed: boolean) => void;
}

export function AvsAdditionalInformationsStep({
  salesChannel,
  onCanProceedChange,
}: AvsAdditionalInformationsStepProps) {
  if (salesChannel === AVS_SELLING_TYPE_FLOTTE) {
    return (
      <AvsFleetAdditionalInformations onCanProceedChange={onCanProceedChange} />
    );
  }

  if (
    salesChannel === AVS_SELLING_TYPE_VDL ||
    salesChannel === AVS_SELLING_TYPE_VDS
  ) {
    return (
      <AvsVdlVdsAdditionalInformations
        salesChannel={salesChannel}
        onCanProceedChange={onCanProceedChange}
      />
    );
  }

  return (
    <Card>
      <CardContent className="text-muted-foreground p-6">
        Sélectionnez un canal de vente à l&apos;étape précédente pour continuer.
      </CardContent>
    </Card>
  );
}
